module.exports = __webpack_public_path__ + "img/64710338000110.77b4060a.png";